/* eslint-disable import/no-duplicates */
import React from 'react';
import PropTypes from 'prop-types';
import Bar from 'components/bar';
import {NONE} from 'constants/mask';
import {STRIPE} from 'constants/mask';
import {isActive} from 'utils/interaction-util';
import {getBarY, getHeight, getWidth} from 'utils/layout-util';
import styles from './index.css';

export default class BarSeries extends React.Component {
  static propTypes = {
    activeIndex: PropTypes.number,
    barHeight: PropTypes.number,
    data: PropTypes.array,
    interactive: PropTypes.bool,
    mask: PropTypes.oneOf([NONE, STRIPE]),
    scale: PropTypes.func,
    style: PropTypes.object,
    verticalSpacing: PropTypes.number,
    width: PropTypes.number,
  };

  static defaultProps = {
    activeIndex: -1,
    barHeight: 0,
    data: [],
    interactive: true,
    mask: '',
    scale: () => {},
    style: {},
    verticalSpacing: 0,
    width: 0,
  };

  render() {
    const {
      activeIndex,
      barHeight,
      data,
      interactive,
      mask,
      scale,
      style,
      verticalSpacing,
      width,
    } = this.props;
    return (
      <g className={styles.BarSeries}>
        {data.map((datum, index) => {
          const {detailIcon, detailLabel, label, value} = datum;
          const active = isActive(activeIndex, index, interactive);
          const height = getHeight(barHeight);
          const barWidth = getWidth(Math.round(scale(value)));
          const y = getBarY(barHeight, verticalSpacing, index);
          return (
            <Bar
              active={active}
              detailIcon={detailIcon}
              detailLabel={detailLabel}
              height={height}
              key={index}
              label={label}
              mask={mask}
              parentWidth={width}
              style={{...style, ...datum.style}}
              width={barWidth}
              y={y}
            />
          );
        })}
      </g>
    );
  }
}
